import { paths } from "./index";
export var mapViewerRoleToDefaultPath = function (roles) {
    var guest = roles.guest, _a = roles.business, owner = _a.owner, employee = _a.employee, admin = roles.admin, rightholder = roles.rightholder, musicEditor = roles.musicEditor;
    if (guest)
        return paths.login();
    if (owner)
        return paths.business.owner.home();
    if (admin)
        return paths.admin.home();
    if (rightholder)
        return paths.rightholder.home();
    if (employee)
        return paths.employee.home();
    if (musicEditor)
        return paths.admin.playlists.index();
    return "/";
};
